
import axios from "axios";
import { OutputBaseProps } from "utils/types/API";

type ApiModuleGroupsOutputProps = OutputBaseProps<{ list: string[]; }>

export const apiModuleGroups = async () => {
    const res = (await axios.get<ApiModuleGroupsOutputProps>("/api/module/groups"))
        .data;
    return res;
};
